import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import GoldDivider from "../components/GoldDivider";

const FAQS = [
  { q: "Comment passer commande ?", a: "Ajoutez vos articles au panier puis validez la commande via le formulaire, ou commandez directement sur WhatsApp en un clic depuis n'importe quelle fiche produit." },
  { q: "Quels sont les modes de paiement ?", a: "Nous acceptons le paiement à la livraison, le Mobile Money (Orange, MTN, Moov, Wave) et la carte bancaire. Le paiement en ligne est confirmé via un lien sécurisé sur WhatsApp." },
  { q: "Livrez-vous en dehors d'Abidjan ?", a: "Oui, nous livrons dans toute la Côte d'Ivoire. Les frais et délais sont confirmés lors de la commande selon votre localité." },
  { q: "Combien de temps pour être livré ?", a: "En général entre 24h et 72h selon votre commune. Vous recevez le suivi par WhatsApp." },
  { q: "Puis-je retourner un article ?", a: "Oui, vous avez 7 jours après réception pour retourner un article dans son état d'origine et obtenir un échange ou un remboursement." },
  { q: "Les produits sont-ils garantis ?", a: "Chaque produit est vérifié avant l'envoi. En cas de défaut, contactez-nous immédiatement, nous trouvons une solution rapidement." },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <div data-testid="faq-page">
      <section className="hero-noir py-20 px-4 md:px-8 text-center">
        <span className="text-xs uppercase tracking-[0.3em] text-[#B8860B]">Aide</span>
        <h1 className="font-display text-4xl md:text-6xl text-white mt-3 mb-4">Questions fréquentes</h1>
        <GoldDivider />
      </section>

      <div className="max-w-3xl mx-auto px-4 md:px-8 py-16 space-y-3">
        {FAQS.map((f, i) => (
          <div key={i} className="border border-neutral-100 rounded-sm overflow-hidden" data-testid={`faq-item-${i}`}>
            <button
              onClick={() => setOpen(open === i ? -1 : i)}
              className="w-full flex items-center justify-between gap-4 p-5 text-left"
            >
              <span className="font-display text-lg md:text-xl text-[#0A0A0A]">{f.q}</span>
              <span className="text-[#B8860B] shrink-0">{open === i ? <Minus size={20} /> : <Plus size={20} />}</span>
            </button>
            {open === i && (
              <div className="px-5 pb-5 text-neutral-600 leading-relaxed">{f.a}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
